import React, {useState, useEffect} from "react";
import styles from "./Masonry.module.css";

import HomeCard from "./HomeCard/HomeCard";
import SegmentedControl from "../../../UI/SegmentedControl/SegmentedControl";

import ProfileImage from "../../../Assets/Images/Profile.jpeg";

import Experience from "./MainCardSections/Experience/Experience";
import Volunteering from "./MainCardSections/Volunteering/Volunteering";
import Education from "./MainCardSections/Education/Education";
import Awards from "./MainCardSections/Awards/Awards";

import ReactCountryFlag from "react-country-flag"
import { FaMapPin, FaRobot } from "react-icons/fa";
import { PiGithubLogoFill } from "react-icons/pi";
import { FaLinkedinIn, FaTrophy, FaPhone } from "react-icons/fa6";
import { LiaNpm } from "react-icons/lia";
import { IoMdBriefcase, IoMdMail, IoMdDownload } from "react-icons/io";
import { BsFillMortarboardFill } from "react-icons/bs";

const Masonry = () => {
    const titles = [
        {text: "Rares", fontSize: "23px"},
        {text: "a student", fontSize: "23px"},
        {text: "a fullstack developer", fontSize: "23px"},
        {text: "expanding my DevOps skills", fontSize: "23px"},
        {text: "passionate about robotics", fontSize: "23px"}
    ]

    const mainContainerSelections = [
        {id: "Experience", name: "Experience", icon: IoMdBriefcase},
        {id: "Education", name: "Education", icon: BsFillMortarboardFill},
        {id: "Awards", name: "Awards", icon: FaTrophy},
        {id: "Volunteering", name: "Volunteering", icon: FaRobot},
    ]

    const languagesSelections = [
        {id: "EN", name: "", icon: <ReactCountryFlag countryCode = "US" style = {{fontSize: "22px", marginLeft: "-5px"}}/>, description: "Language competence: C1"},
        {id: "RO", name: "", icon: <ReactCountryFlag countryCode = "RO" style = {{fontSize: "22px", marginLeft: "-5px"}}/>, description: "Language competence: Native"},
    ]

    const [currentTitle, setCurrentTitle] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);

    const [mainCardActive, setMainCardActive] = useState("Experience");

    useEffect(() => {
        const interval = setInterval(() => {
            setIsAnimating(true);

            setTimeout(() => {
                setCurrentTitle((prev) => (prev + 1) % titles.length);
            }, 500)

            setTimeout(() => {    
                setIsAnimating(false);
            }, 1000);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className = {styles.container}>
            <div className = {styles.row}>
                <div className = {styles.column}>
                    <div className = {styles.mainTitleContainer}>
                        <h1 className = {styles.mainTitle}>Heyo 👋 I'm</h1>
                        <div className = {`${styles.mainTitleDynamic} ${isAnimating ? styles.flip : ""}`}>
                            <h1 className = {styles.mainTitle}>{titles[currentTitle].text}</h1>
                        </div>
                    </div>

                    <HomeCard widthUnits = {33} heightUnits = {18}>
                        <div className = {styles.mainCardContainer}>
                            <div className = {styles.mainCardContentContainer}>
                                {mainCardActive === "Experience" && (
                                    <Experience />
                                )}
                                {mainCardActive === "Education" && (
                                    <Education />
                                )}
                                {mainCardActive === "Awards" && (
                                    <Awards />
                                )}
                                {mainCardActive === "Volunteering" && (
                                    <Volunteering />
                                )}

                            </div>

                            <SegmentedControl onChange = {(id) => {setMainCardActive(id)}} selections = {mainContainerSelections} customizations = {{backgroundColor: "var(--GLASS_backgroundDarker)", backgroundColorActive: "var(--GLASS_backgroundAccent)", foregroundColor: "var(--COLOR_textPrimary)", foregroundColorActive: "var(--COLOR_textOnAccent)", widthBehaviour: "scrollIndividualFillParent", padding: "4px 8px", borderRadiusTop: "0px", borderRadiusBottom: "8px"}} />
                        </div>
                    </HomeCard>

                    <div className = {styles.row}>
                        <a href = "/Rares-Nandra-CV.pdf" download = "Rares-Nandra-CV.pdf" style={{textDecoration: "none"}}>
                        <HomeCard widthUnits = {20} heightUnits = {2} isClickable = {true}>
                            <div className = {styles.textAndIconContainer}>
                                <p className = {styles.text}>Download CV</p>
                                <IoMdDownload className = {styles.icon} />
                            </div>
                        </HomeCard>
                        </a>

                        <a href="mailto:rares.nandra@proton.me" style={{textDecoration: "none"}}>
                        <HomeCard widthUnits = {12} heightUnits = {2} isClickable = {true}>
                            <div className = {styles.textAndIconContainer}>
                                <p className = {styles.text}>rares.nandra@proton.me</p>
                                <IoMdMail className = {styles.icon} />
                            </div>
                        </HomeCard>
                        </a>
                    </div>
                </div>
                
                <div className = {styles.column}>
                    <div className = {styles.row}>
                        <div className = {styles.column}>
                            <a href="https://github.com/rares-nandra" target = "_blank" style={{textDecoration: "none"}}>
                            <HomeCard widthUnits = {2} heightUnits = {2} isClickable = {true} background = {"var(--COLOR_backgroundPrimary)"}>
                                <div className = {styles.centeredContainer}>
                                    <PiGithubLogoFill className = {styles.icon} />
                                </div>
                            </HomeCard>
                            </a>
                            
                            <a href="https://www.npmjs.com/~rares_nandra" target = "_blank" style={{textDecoration: "none"}}>
                            <HomeCard widthUnits = {2} heightUnits = {2} isClickable = {true} background = {"var(--COLOR_backgroundPrimary)"}>
                                <div className = {styles.centeredContainer}>
                                    <LiaNpm className = {styles.icon} />
                                </div>
                            </HomeCard>
                            </a>

                            <a href="https://www.linkedin.com/in/rares-nandra/" target = "_blank" style={{textDecoration: "none"}}>
                            <HomeCard widthUnits = {2} heightUnits = {2} isClickable = {true} background = {"var(--COLOR_backgroundPrimary)"}>
                                <div className = {styles.centeredContainer}>
                                    <FaLinkedinIn className = {styles.icon} />
                                </div>
                            </HomeCard>
                            </a>
                        </div>

                        <div className = {styles.column}>
                            <HomeCard widthUnits = {5} heightUnits = {5}>
                                <img src = {ProfileImage} className = {styles.image} />
                            </HomeCard>

                            <HomeCard widthUnits = {5} heightUnits = {2}>
                                <SegmentedControl onChange = {(id) => {console.log(id)}} selections = {languagesSelections} customizations = {{backgroundColor: "rgba(0, 0, 0, 0)", backgroundColorActive: "var(--GLASS_backgroundDarker)", foregroundColor: "var(--COLOR_textPrimary)", foregroundColorActive: "var(--COLOR_textPrimary)", widthBehaviour: "scrollIndividualFillParent", heigthBehaviour: "fillParent", padding: "4px 8px", borderRadiusTop: "0px", borderRadiusBottom: "8px"}} />
                            </HomeCard>
                        </div>
                    </div>
                    
                    <HomeCard widthUnits = {8} heightUnits = {2} padding = "2px 5px">
                        <div className = {styles.locationContainer}>
                            <FaMapPin className = {styles.icon} />

                            <div className = {styles.locationContainerText}>
                                <p className = {styles.text}>Cluj-Napoca,</p>
                                <p className = {styles.text}>Romania</p>
                            </div>
                        </div>
                    </HomeCard>
                    

                    <HomeCard widthUnits = {8} heightUnits = {12}>
                    
                    </HomeCard>
                </div>
            </div>
        </div>
    );
};

export default Masonry;